










































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import _ from 'lodash';
import MyList from '@/mixins/list';

import http from '@/request';
import moment from "moment";
import filesaver from "file-saver";
import List from './components/list.vue';

@Component({
  components: {
    List,
  },
})
export default class extends Mixins(MyList) {
    @Prop() clickParams!: any
    @Prop() stadiumId!: number;
    page = 1

    total_count = 0

    total_cost = -1

    total_money = 0

    loading = false

    exModalVisible = false;
    exModalContent="";
    exModalTimer:any;

    busy = false

    title = ''

    params: any = {}

    total_page = 0

    mounted() {
      this.title = this.clickParams.name;

      this.params = this.clickParams.click.param;

      this.total_count = this.params.total_count;
      this.total_cost = this.params.total_cost;
      this.total_money = this.params.total_money;

      this.total_page = Math.ceil(this.total_count / 10);

      this.fetchData(1);
    }

    async fetchData(page: number) {
      this.page = page;
      this.loading = true;

      const params = {
        page: this.page,
        ...this.params,
      };

      http.get('/settlement-record/list-for-settle-v2', { params }).then((res: any) => {
        if (res && res.Data) {
          if (res.Data.items) {
            this.data = _.concat(this.data, res.Data.items);
          }
        }
      });

      this.loading = false;
    }

    handleInfiniteOnLoad() {
      if (this.total_page > this.page) {
        this.fetchData(this.page + 1);
      }
    }

    handleExport(){
      this.$confirm({
      title: "确认信息",
      content: "确定要导出数据吗",
      onOk: async () => {
          // console.log(res);

          // 导出的文件名
          const { breadcrumbs } = this.$store.state;
          const filename: string = breadcrumbs[breadcrumbs.length - 1].breadcrumbName;

          const params = {
            is_export: 1,
            stadium_id:this.stadiumId,
            ...this.params,
          };

          if (this.env.VUE_APP_CURRENTMODE === "development" || this.env.VUE_APP_CURRENTMODE === "dev") {
            params.dev=true
            const res = await this.$store.dispatch('finance/exportBill', params);
            if (res && res.data) {
              const blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              });

              filesaver.saveAs(blob, `${filename}${moment().format("YYYY-MM-DD HH:mm:ss")}.xlsx`);
            }
          } else {
            const res = await this.$store.dispatch('finance/exportBill', params);
            if (res && res.Data) {
              if(res.Data.substr(0,4)=='http'){
                this.$info({
                  title: "导出成功",
                  content: (h: any) =>
                    h("div", {}, [
                      h("span", "导出成功，点击链接下载"),
                      h(
                        "a",
                        {
                          attrs: {
                            href: res.Data
                          }
                        },
                        res.Data
                      )
                    ])
                });
              } else {
                this.startExMode(res.Data);
              }
            }
          }
        }
      });
    }

    startExMode(key:string){
      this.exModalContent=""
      this.exModalVisible=true
      const that=this
      this.exModalTimer=setInterval(async()=>{
        const res = await that.$store.dispatch("bill/exportCheck", {key});
        if(res.Code!=200){
          clearInterval(that.exModalTimer)
          that.exModalContent=res.Message
        } else if(res.Data){
          clearInterval(that.exModalTimer)
          this.exModalVisible=false
          that.$info({
            title: "导出成功",
            content: (h: any) =>
              h("div", {}, [
                h("span", "导出成功，点击链接下载"),
                h(
                  "a",
                  {
                    attrs: {
                      href: res.Data
                    }
                  },
                  res.Data
                )
              ])
          });
        }
      },10000)
    }

    cancelExModal(){
      this.exModalVisible=false
      if(this.exModalTimer){
        clearInterval(this.exModalTimer)
      }
    }

}
